import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';
import Roles from 'utils/enums/Roles';

import { ArticleDetail } from './ArticleDetail';
import { ArticlesList } from './ArticlesList';

export const Articles = ({ currentUser }) => {
  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.STUDENT, Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR],
              entitlements: [Roles.JOBMARKET_ADMIN]
            }}
            user={currentUser}
          >
            <ArticlesList />
          </PrivateRoute>
        }
      />
      <Route
        path=":id"
        element={
          <PrivateRoute
            requires={{
              roles: [Roles.STUDENT, Roles.EMPLOYEE, Roles.HIWI, Roles.LECTURER, Roles.PROFESSOR],
              entitlements: [Roles.JOBMARKET_ADMIN]
            }}
            user={currentUser}
          >
            <ArticleDetail />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export { Calendar } from './Calendar';
